import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PhonePrefixService } from '../../services/phone-prefix.service';
import { TranslateModule } from "@ngx-translate/core";
import { ApiService } from 'src/app/services/communications/api.service';
import { ValidatorsService } from '../../services/validators.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PhonePrefixOption } from '../../interfaces/PhonePrefixOption';



export interface AddContactDialogData {
  email?: string;
  phoneNumber?: string;
  phonePrefix?: string;
}

@Component({
  selector: 'app-add-new-contact',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatProgressSpinnerModule, TranslateModule, MatAutocompleteModule],
  templateUrl: './add-new-contact.component.html',
  styleUrls: ['./add-new-contact.component.scss']
})

export class AddContactDialogComponent {
 
  contactForm: FormGroup;
  phonePrefixOptions: PhonePrefixOption[] = [];
  filteredPrefixes: PhonePrefixOption[] = [];
  formSubmitted = false;

  constructor(private fb: FormBuilder, private dialogRef: MatDialogRef<AddContactDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AddContactDialogData = {}, private phonePrefixService: PhonePrefixService,
    private apiService: ApiService, private validatorService: ValidatorsService) {

    this.loadPhonePrefixes();

    this.contactForm = this.fb.group({
      name: ['', [Validators.required]],
      company: [''],
      phonePrefix: [data?.phonePrefix ? this.phonePrefixOptions.find(p => p.dial_code === data.phonePrefix) ?? null : null],
      phoneNumber: [data?.phoneNumber || ''],
      email: [data?.email || '', [validatorService.emailValidator()]],
    }, {
      validators: [
        validatorService.atLeastOneContactMethod(),
        validatorService.phoneValidator()
      ]
    });
  }

  displayPrefix(prefix: PhonePrefixOption): string {
    if (!prefix) return '';
    return prefix ? `${prefix.display}` : '';
  }

  onAutocompleteOpened() {
    this.filteredPrefixes = [...this.phonePrefixOptions];
    setTimeout(() => {
      const selected = document.querySelector('.mat-mdc-option[aria-selected="true"]');
      selected?.scrollIntoView({ block: 'center' });
    }, 0);
  }

  private loadPhonePrefixes(): void {
    this.phonePrefixService.getPhonePrefixOptions().subscribe({ 
      next: (options) => {
        this.phonePrefixOptions = options;
        this.filteredPrefixes = [...this.phonePrefixOptions];

        this.contactForm.get('phonePrefix')!.valueChanges.subscribe(value => {
          const search = (value || '').toString().toLowerCase();
          this.filteredPrefixes = this.phonePrefixOptions.filter(p =>
            p.display.toLowerCase().includes(search) || p.dial_code.includes(search)
          );

          console.log("list", this.filteredPrefixes.length);
        });
        
      },
      error: (error) => {
        console.error('Error loading phone prefixes:', error);
        this.phonePrefixOptions = [{ dial_code: '-1', display: '---' }];
      }
    });
  }


  onSubmit(): void {
    this.formSubmitted = true;
    this.contactForm.markAllAsTouched();

    if (this.contactForm.valid) {
      this.sendAddContactForm();
    }
  }

  private sendAddContactForm(): void {
    const formValue = this.contactForm.getRawValue();
    const name = formValue.name?.trim();
    const company = formValue.company?.trim() || null;
    const email = formValue.email?.trim() || null;
    const phonePrefix = formValue.phonePrefix?.dial_code ?? '';
    const phoneNumber = formValue.phoneNumber?.trim() || null;

    this.apiService.addNewContact(name, company, email, phonePrefix, phoneNumber).subscribe({
      next: (result) => {
        if (result) {
          this.dialogRef.close(true);
        } else {
          this.contactForm.setErrors({ serverError: 'ADD_CONTACT_DIALOG.CONTACT_ADDED_ERROR' }); 
          
        }
      },
      error: (error) => {
        console.error('Error en la petición:', error);
        this.contactForm.setErrors({ serverError: 'ADD_CONTACT_DIALOG.CONTACT_ADDED_ERROR' });
      }
    });
  }

}
